/**
* Sets CSS custom properties
* @module set-css-props
*/

/**
 * Sets CSS custom property `--scrollbarWidth` value if a scrollbar is visible
 * 
 */
export function setCSSPropScrollbarWidth() {
  if (window.innerWidth !== document.body.clientWidth) {
      const scrollbarWidth = (window.innerWidth - document.body.clientWidth);

      document.documentElement.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);
  }
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/base/set-css-props.js